/* tslint:disable */
/* eslint-disable */
/**
 * File API
 * API for managing files
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentUrlDto
 */
export interface DocumentUrlDto {
    /**
     * Name of the document file
     * @type {string}
     * @memberof DocumentUrlDto
     */
    fileName?: string;
    /**
     * Temporary URL to access the document
     * @type {string}
     * @memberof DocumentUrlDto
     */
    url?: string;
}

/**
 * Check if a given object implements the DocumentUrlDto interface.
 */
export function instanceOfDocumentUrlDto(value: object): value is DocumentUrlDto {
    return true;
}

export function DocumentUrlDtoFromJSON(json: any): DocumentUrlDto {
    return DocumentUrlDtoFromJSONTyped(json, false);
}

export function DocumentUrlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentUrlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function DocumentUrlDtoToJSON(json: any): DocumentUrlDto {
    return DocumentUrlDtoToJSONTyped(json, false);
}

export function DocumentUrlDtoToJSONTyped(value?: DocumentUrlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'url': value['url'],
    };
}

